export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8331.6d0454d9.jpg";